export const habaUser = {
  habaCommonUserInformation: {
    nameAndJob: '{{firstName}} {{lastName}}, {{job}}',
    profileImageAlt: 'User profile picture',
    validation: {
      invalidName:
        'Please check that your entered name does not contain numbers or unusual symbols (%&$...).',
    },
    underConstruction: {
      headline: '"My customer account" will be available again soon!',
      subHeadline: 'Due to a system adjustment, this function is currently unavailable.',
      list1: 'The data in your existing customer account will not be lost',
      list2: 'You are welcome to sign up for the newsletter to be immediately informed about news',
      list3: 'Or discover here',
      linkText: 'our new products',
      buttonText: 'Sign up for newsletter',
    },
  },
  habaLoginForm: {
    heading: 'Welcome back',
    forgotPassword: 'Forgot password?',
    signIn: 'Sign in',
    register: 'Register now',
    dontHaveAccount: "Don't have a customer account yet?",
    emailAddress: {
      label: 'Email address',
      wrongEmailFormat: 'Please enter a valid email address.',
    },
    password: {
      label: 'Password',
      passwordRequired: 'Please enter a password.',
    },
    guestCheckout: 'Order as guest',
    successfulLogin: 'Welcome! Login successful',
    accountCannotBeUsed: 'You cannot sign in with this account. Try a different email address.',
    reminderEmail: {
      title: 'Email not yet confirmed!',
      description:
        '<strong>You have not yet confirmed your email address. To sign in with us,</strong> Please confirm your email address, then we can create your customer account. We have sent you an email. Simply click on the confirmation link in the email.<br/><br/>If you have not received an email, please check your spam folder or request a new email.',
      resendEmail: 'Resend email',
      infoTitle: 'Note:',
      infoText:
        "Please note that the link in the received email is <strong>only available for 2 hours</strong>.<br/><br/>If you do not confirm your email address, <strong>your account will be deleted in 2 weeks</strong> from the time of account registration. So don't forget to click on the confirmation link.<br/><br/><strong>3 days</strong> before the deletion of the <strong>account</strong> you will receive a reminder email with a link through which you can request a new confirmation email.",
      activationLinkSent: 'Activation email was sent successfully.',
      activationLinkError:
        'An error occurred while sending the activation email. Please try again later.',
    },
  },
  habaRegisterForm: {
    registrationInfoHeadline: 'With a customer account, you can enjoy the following benefits: ',
    iconListFirstItemText: 'Easily reorder',
    iconListSecondItemText: 'Transparent delivery tracking',
    iconListThirdItemText: 'Simple returns',
    heading: 'Create new customer account',
    register: 'Register now',
    registerAsGuest: 'Continue as guest customer',
    emailAddress: {
      label: 'Email address',
      wrongEmailFormat: 'Please enter a valid email address.',
    },
    password: {
      label: 'Password',
      labelText:
        'To keep your login data particularly secure, you can change your password at any time.',
      passwordRequired:
        'At least 6 characters, at least one special character, at least one uppercase letter, at least one lowercase letter, at least one number',
      passwordForbiddenCharsAndTooShort: 'At least 6 characters',
      passwordNoSpecialChars: 'At least one special character',
      passwordNoUpperCase: 'At least one uppercase letter',
      passwordNoLowerCase: 'At least one lowercase letter',
      passwordNoDigits: 'At least one number',
    },
    passwordRepeat: {
      label: 'Repeat password',
      passwordRequired: 'Password and password repeat do not match.',
    },
    postRegisterMessage:
      'Please confirm your email address, then we can create your customer account.<br/>We have sent you an email. Simply click on the confirmation link in the email.',
    firstName: {
      label: 'First name',
      required: 'Required field',
    },
    lastName: {
      label: 'Last name',
      required: 'Required field',
    },
    newsletter: 'Sign up for {{shop}} newsletter',
    pendingPage: {
      headline: 'Thank you for your registration request.',
      subline:
        'You will now receive an email with a confirmation link. Please check your email inbox.',
      infoBlock: 'The account will be created after you click on the confirmation link.',
      linkText: 'Back to homepage',
    },
    privacy: {
      label: 'I agree to the <a>privacy policy</a>.',
      required: 'Please confirm that you have read and accepted our privacy policy.',
    },
    checkoutRegister: {
      headline: 'Order as new/guest customer',
      orderAsGuestTitle: 'Order as guest?',
      orderAsGuestText: 'Yes, I would like to order as a guest',
    },
  },
  habaNavLogin: {
    login: 'Sign in',
    register: 'Register',
    logoutLink: 'Sign out',
    logout: 'Not {{name}}?',
    successfulLogout: 'Logout successful.',
    loginIncentiveText: 'Sign in with your customer account and benefit from Family Club offers.',
    loginIncentiveTextHaba:
      'Sign in with your customer account and benefit from quick orders and discounts.',
    modal: {
      headline: 'My account',
      myProfile: 'My profile',
    },
    myAccount: {
      overview: 'Overview',
      orders: 'Orders',
      accountData: 'Customer data',
      deliveryAddresses: 'Delivery addresses',
    },
  },
  habaForgottenPassword: {
    heading: {
      forgotPassword: 'Forgot password? <br/> No problem!',
      resetMailSend: 'Reset password',
      resetPassword: 'Assign new password',
    },
    infoText: {
      forgotPassword:
        'Please use the email address that you used to register your account. <br/> We will then send you a link that you can use to assign a new password.',
      resetMailSend: {
        firstPart: 'We have sent you an email to <b>{{ emailAddress }}</b>.',
        secondPart: 'Please follow the link in the email to assign a new password.',
      },
      noEmailInfo: {
        headline: 'No message received?',
        reason1: 'Check if the email address is correct',
        reason2: 'Check your spam folder',
        newUser: 'Are you new to HABA? Then create ',
        newUserLinkText: 'here',
        yourAccount: ' your customer account',
        backToAccount: 'Back to sign in',
      },
      resetPassword:
        'To keep your account secure, your password must contain at least the following characters:',
    },
    emailAddress: {
      label: 'Email address',
      wrongEmailFormat: 'Please enter a valid email address.',
    },
    button: {
      submitResetPassword: 'Reset password',
      backToLogin: 'Back to sign in',
      submitNewPassword: 'Assign new password',
    },
    errorMessage:
      'Due to technical problems, the password reset process could not be executed. Try again later...',
    tokenExpired: 'Your token has expired. Please request a new forgot password email.',
    passwordChangeSuccess: {
      heading: 'New password successfully assigned.',
      message: 'Now sign in with your new password.',
      button: 'TO SIGN IN',
    },
  },
  habaProRegisterForm: {
    button: {
      submit: 'Register now',
    },
    form: {
      additionalAddressInfo: 'Additional address info',
      company: 'Company',
      contactPerson: 'Contact person',
      country: 'Country',
      firstName: 'First name',
      gtc: 'I acknowledge the privacy policy and the terms and conditions. You have a legal 14-day right of withdrawal. Details and exceptions in our withdrawal instruction.',
      industry: 'Industry',
      institution: 'Institution',
      lastName: 'Last name',
      madam: 'Mrs.',
      optional: '(optional)',
      phone: 'Phone number',
      sir: 'Mr.',
      street: 'Street',
      streetNumber: 'House number',
      town: 'City',
      zip: 'Postal code',
    },
    formError: {
      gtc: 'Please accept the terms and conditions.',
      phoneNumberFormat: 'Please in format: +4912345678',
      zipCodeLength: 'The postal code must be {{length}} digits long.',
    },
    messages: {
      registeredSuccessfully: 'Successfully registered.',
      userAlreadyExists: 'User already exists.',
    },
  },
  habaAccountOverview: {
    personalProfile: 'Personal profile',
    personalProfileMessage:
      'This is your personal {{storeName}} profile, here you will find all important information and lots of inspiration!',
    pageTitle: 'Welcome to your customer account',
    pageDescription: 'lorem ipsum set delor',
    card: {
      orders: {
        title: 'My orders',
        text: '',
        btnText: 'To order overview',
      },
      wishlist: {
        title: 'My wishlists',
        text: '',
        btnText: 'To wishlist',
      },
      customerData: {
        title: 'My customer data',
        text: '',
        btnText: 'To my data',
      },
      delivery: {
        title: 'My delivery addresses',
        text: '',
        btnText: 'To delivery addresses',
      },
    },
  },
  habaCustomerData: {
    loginData: {
      changeEmailAndSave: 'Change email address & save',
      changeLoginData: 'Change login data',
      changePasswordAndSave: 'Change password & save',
      confirmNewEmail: 'Confirm new email address',
      confirmNewPassword: 'Confirm new password',
      currentEmail: 'Current email address',
      currentPassword: 'Current password',
      currentPasswordRequired: 'Please enter your current password.',
      emailsMustMatch: 'Email addresses must match',
      invalidEmail: 'Please enter a valid email address',
      newEmail: 'New email address',
      newPassword: 'New password',
      emailUpdated: 'Email address has been updated',
      passwordUpdated: 'Password has been updated',
      changeError: "Unfortunately that didn't work, please try again",
    },
    deliveryAddress: {
      addDeliveryAddress: 'Add delivery address',
      defaultDeliveryAddress: 'Default delivery address',
      delete: 'Remove',
      deleteDeliveryAddress: 'Remove delivery address?',
      deliveryAddresses: 'Delivery addresses',
      edit: 'Edit',
      newDeliveryAddress: 'Add a delivery address',
      pendingOrders: 'Pending orders that will be sent to this address will not be cancelled.',
      phoneNumber: 'Phone no.',
      updateDeliveryAddress: 'Update delivery address',
    },
    overview: {
      address: 'Address',
      billingAddress: 'Billing address',
      emailAddress: 'Email address',
      loginData: 'Login data',
      myData: 'My data',
      name: 'Name',
      noBillingAddress: "You don't have a billing address yet.",
      password: 'Password',
      personalData: 'Personal data',
      phoneNumber: 'Phone number',
    },
    childrenData: {
      createNew: {
        btn: 'Add child',
        heading1: 'New birthday child',
        heading2: 'Why do we want to get to know the members of your family?',
        desc1: "So far you haven't added a birthday for your child yet. <br/>Add one now.",
        Privacy:
          'By clicking "Save" you agree to the processing of children\'s data for advertising purposes. You can object to the use of your data at any time. To do this, go to "Manage children\'s data" in your customer account and edit/remove the desired data. Further information can be found in the <a href="https://www.haba-play.com/de-de/s/datenschutz">privacy policy</a>.',
        option1: 'Birthday gift',
        option2: 'Tailored offers',
        option3: 'Even more benefits',
        optDesc1:
          'For your child\'s birthday exclusively for newsletter subscribers. <a href="{{url}}"><u>Sign up here.</u></a>',
        optDesc2: 'Individual offers specially tailored to your family. <br/> <br/>',
        optDesc3: 'HABA accompanies families from pregnancy through birth to the teenage years.',
        addressLimit: 'You have reached the maximum of 10 children.',
        addressLimitText:
          'If you want to add a new birthday child, you must delete one of the added birthdays.',
        successMessage: 'New birthday has been created',
        errorMessage: 'Something went wrong. Please try again.',
        birthDateMonthsMessage: '<b>{{number}} months</b> left',
        birthDateMonthMessage: '<b>{{number}} month</b> left',
        birthDateDaysMessage: '<b>{{number}} days</b> left',
        birthDateDayMessage: '<b>{{number}} day</b> left',
        todayIsBirthDay: '<b>Today</b>',
        tomorrowIsBirthDay: '<b>Tomorrow</b>',
      },
      edit: {
        heading1: '',
        desc1:
          "Enter your child's date of birth. If you have multiple children, you can add a birthday for each one. <br/>You can add up to 10 birthdays.",
        cardHeading: 'Has your child already been born?',
        option1: 'Already born child',
        option2: 'Expected date of birth during pregnancy',
        gender: 'Gender',
        name: 'Have you already thought of a name for your child?',
        unBornNameLabel: 'Have you thought of a name for the future child?',
        noGenderLabel: "I don't know yet",
        dob: 'Date of birth',
        dayOfBirth: 'Birthday',
        kind: 'Child ',
        mainSection: "My children's data",
        boy: 'Boy',
        girl: 'Girl',
        divers: 'Diverse',
        pregnant: 'Pregnant',
        day: 'Day',
        month: 'Month',
        year: 'Year',
        pastDateError: 'The date must be in the past.',
        futureDateError: 'The date must be in the future.',
        successMessage: 'Data successfully changed',
      },
      delete: {
        title: 'Delete birthday',
        desc: 'Do you really want to delete the selected birthday?',
        btnText: 'Delete birthday',
        successMessage: 'Date of birth successfully deleted',
      },
    },
    myAccountSectionData: {
      standardShippingAddress: 'This is your <b> default delivery address </b>',
      standardBillingAddress: 'This is your <b> default billing address </b>',
      makeStandardShippingAddress: 'Set as <b> default delivery address </b>',
      makeStandardBillingAddress: 'Set as <b> default billing address </b>',
      editNewAddressHeadline: 'Edit address',
      editNewAddressSubHeadline:
        'Please enter an address that you want to save and to which you want your items delivered.',
      newAddressHeadline: 'Add new address',
      noAddressHeadline: 'No address added',
      noAddressText: "You haven't added an address for yourself yet.<br/>Add an address now.",
      personalData: 'What are your personal details?',
      deleteHeadline: 'Delete address',
      disableDeleteBtnText:
        'This address cannot be deleted as long as it is set as the default delivery and billing address. To delete the address, another address must be selected as the default address. <br/><br/> Currently there is only one address available. Add a <b>new address</b> to change the default address.',
      deleteTextInfo:
        'Do you really want to delete the selected address?<br/>Once deleted, it will no longer appear in your delivery and billing address options.',
      tooltipBilling:
        'When placing an order, this address will be displayed on the invoice document by default. The address can also be changed during the order.<br /> <br/> You currently have only one address added. To change the default billing address, you need to <b>add a new address.</b>',
      tooltipShipping:
        'This address is set as the main delivery address for order control. You can change it by selecting another of your addresses.',
      tooltipCountrySelection:
        'Shipping is only possible within the selected country version of the online shop. The country can be changed at the bottom of the page. <br />The delivery address can also be easily added or changed during the order. Any address can be used as a billing address - regardless of which country.',
      tooltipCancelBtn:
        'You cannot delete this address as long as it is set as billing address or delivery address. After you have selected another address as your main address, this one can be deleted.<br /> <br/> You currently have one address added. To change the main delivery address, you need to <b>add a new address.</b>',
    },
    invoiceDownload: {
      headline: 'Invoice request',
      secondHeadline: 'You no longer have the invoice at hand and need a copy of the invoice?',
      descriptionPart1:
        'Simply download it here. Enter your customer number and your invoice number in the following input fields and click on download.',
      descriptionPart2:
        'For data protection reasons, it is checked in the background whether the customer number and invoice number belong together - only then is downloading possible.',
      descriptionPart3:
        'You can only download one invoice at a time. For multiple invoices, you must perform these steps one after the other.',
      inputCustomerNr: 'Customer number',
      inputInvoiceNr: 'Invoice number',
      inputCustomerNrError: 'The customer number is required.',
      inputInvoiceNrError: 'The invoice number is required.',
      submitButton: 'Download invoice',
      notFound:
        'An invoice for the specified customer number and invoice number could not be found.',
    },
  },
  habaOrderHistory: {
    loading: 'Data is loading...',
    empty: {
      noOrder:
        "So far you haven't placed any orders in our online shop. Take a look around now and explore our large selection of products...",
    },
    headline: 'My orders',
    orderItem: {
      headline: {
        prefix: 'Order from',
      },
      details: {
        orderNumber: 'Order number',
        orderValue: 'Total amount',
        status: 'Status',
      },
      button: 'View order',
    },
    detailView: {
      headline: 'Order',
      backLink: 'My orders',
      label: {
        orderDate: 'Order date',
        shippingMethod: 'Shipping method',
        deliveryAddress: 'Delivery address',
        paymentAddress: 'Billing address',
        paymentMethod: 'Payment method',
        orderTotal: 'Total amount',
        totalTax: 'VAT included {{percentFormatted}}',
        deliveryCosts: 'Shipping costs',
        discounts: 'discount included',
        articleValue: 'Value of goods',
        order: 'Your order',
        status: 'Status',
        tracking: 'Package tracking',
        numberOfShipments: 'Number of shipments',
        shipmentStatus: 'Shipment status',
        shipments: 'Shipment {{number}} of {{total}}',
        canceledArticles: 'Cancelled items',
        totalGiftCardAmount: 'Gift card value redeemed',
        downloadInvoice: 'Download invoice',
      },
      entries: {
        quantity: 'Quantity: {{quantity}}',
        color: 'Color:',
        size: 'Size:',
      },
      savings: 'Your savings',
      initialPrice: 'Original item value',
      includedDiscount: 'Included discount',
      voucherRedemption: 'Voucher redemption',
      addedDiscountCodes: 'Added discount codes',
    },
  },
  habaPasswordRules: {
    signLength: '6 characters',
    specialChar: 'one special character',
    charUppercase: 'one uppercase letter',
    charLowercase: 'one lowercase letter',
  },
};
